import Form from './form'

export default (function() {

  return {
    init: function() {

      document.addEventListener('DOMContentLoaded', () => {
        [...document.querySelectorAll('.js-form-validate')].forEach(function(form) {
          return new Form(form);
        });
      })
    }
  }

})();
